import { type LocalStorage2faKey } from '@pkg/types';

import config from '@app/config';

export function recentPromptIgnored(key: LocalStorage2faKey) {
    const currentTime = new Date().getTime();

    // TODO: This should be a `convertToTimeFormat()` type of utility function.
    const delay = config.delayBetween2FAPrompts * 24 * 60 * 60 * 1000;

    const lastPromptTime = Number(localStorage.getItem(key)) ?? 0;
    const nextPromptTime = new Date(lastPromptTime).getTime() + delay;

    return currentTime > nextPromptTime;
}
